var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('new-password-form',{attrs:{"title":_vm.title,"apiErrors":_vm.apiErrors,"isLoading":_vm.isLoading},on:{"formSubmitted":_vm.onFormSubmitted,"clearApiErrors":function($event){return _vm.onClearApiErrors($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }